import React, {useContext, useEffect, useState} from 'react';
import {Box, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {LocaleContext} from '../../../ts/routing/LangRouter';
import {getAppointmentPageUrl} from '../../../ts/routing/routingConstants/AppUrls';
import {useTranslation} from 'react-i18next';
import {useStyles} from './styles';


const CarWindow = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const {locale} = useContext(LocaleContext);
    const {t} = useTranslation();
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_KEY}/arscustom/public/services/tint-glass-services`,{
                        params: {"special": false},
                    }
                );

                // Filter for non-special services and ensure enabled is true
                const nonSpecialServices = response.data
                    .map(service => ({
                        id: service.id,
                        model: locale === 'fr' ? service.modelFr : service.modelEn,
                        modelEn: service.modelEn,
                        modelFr: service.modelFr,
                        price: service.price,
                        discountPrice: service.discountPrice,
                        currency: service.currency,
                        imageUrl: service.imageUrl,
                        isSpecial: service.isSpecial,
                    }));
                setServices(nonSpecialServices);
                setError(null);
            } catch (error) {
                console.error('Error fetching tint glass services:', error);
                setError(t('common.error'));
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, [locale, t]);

    if (loading) {
        return <Typography sx={{textAlign: 'center', my: 2}}>{t('common.loading')}</Typography>;
    }

    if (error) {
        return <Typography color="error" sx={{textAlign: 'center', my: 2}}>{error}</Typography>;
    }

    if (services.length === 0) {
        return <Typography sx={{textAlign: 'center', my: 2}}>{t('common.no_services')}</Typography>;
    }

    return (
        <Box className={classes.container}>
            {services.map((service) => (
                <Box className={classes.wrapper} key={service.id}>
                    {/*{service.discountPrice > 0 && (*/}
                    {/*    <Box className={classes.box}>*/}
                    {/*        <span>{`${service.discountPrice}%`}</span>*/}
                    {/*    </Box>*/}
                    {/*)}*/}
                    <img
                        className={classes.car}
                        src={service.imageUrl}
                        alt={`Car Window ${service.model}`}
                    />
                    <Box className={classes.title}>
                        {service.model}
                    </Box>

                    {service.discountPrice !== service.price ? (
                        <Box>
                            {/* Original price, crossed out */}
                            <Box className={classes.discountedPrice}>
                                {`${service.price} ${service.currency}`}
                            </Box>

                            {/* Actual discounted price */}
                            <Box className={classes.newPrice}>
                                {`${service.discountPrice} ${service.currency}`}
                            </Box>
                        </Box>
                    ) : (
                        // No discount, just show normal price
                        <Box className={classes.newPrice}>
                            {`${service.price} ${service.currency}`}
                        </Box>
                    )}

                    <Box className={classes.btn_box}>
                        <button
                            className={classes.button}
                            onClick={() =>
                                navigate(getAppointmentPageUrl(locale), {
                                    state: {
                                        tintedGlass: {
                                            id: service.id,
                                            modelEn: service.modelEn,
                                            modelFr: service.modelFr,
                                            price: service.price,
                                            discountPrice: service.discountPrice,
                                            currency: service.currency,
                                            isSpecial: service.isSpecial,
                                        },
                                        model_en: service.modelEn,
                                        model_fr: service.modelFr,
                                        price: service.price,
                                        discountPrice: service.discountPrice,
                                        isSpecial: service.isSpecial,
                                        amount: service.discountPrice
                                    },
                                })
                            }
                        >
                            {t('common.book_appointment')}
                        </button>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default CarWindow;

CarWindow.propTypes = {};